/** Custom Columns + grid keys for Sales Order Details Refund tab (`RefundOrders`). */
export var SALES_ORDER_DETAILS_REFUND_COLUMN_KEYS = [
    "refundId",
    "createdDate",
    "orderNo",
    "commission",
    "teamManagerCommission",
    "refundSubTotal",
    "orderStatus",
    "salesMethod",
];
export var SALES_ORDER_DETAILS_REFUND_COLUMN_DEFS = [
    { key: "refundId", labelKey: "refundOrders_column1" },
    { key: "createdDate", labelKey: "refundOrders_column2" },
    { key: "orderNo", labelKey: "refundOrders_column3" },
    { key: "commission", labelKey: "refundOrders_column5" },
    { key: "teamManagerCommission", labelKey: "refundOrders_column6" },
    { key: "refundSubTotal", labelKey: "refundOrders_column8" },
    { key: "orderStatus", labelKey: "refundOrders_column9" },
    { key: "salesMethod", labelKey: "refundOrders_column10" },
];
export function createDefaultSalesOrderDetailsRefundColumnVisibility() {
    var visibility = {};
    for (var _i = 0, SALES_ORDER_DETAILS_REFUND_COLUMN_DEFS_1 = SALES_ORDER_DETAILS_REFUND_COLUMN_DEFS; _i < SALES_ORDER_DETAILS_REFUND_COLUMN_DEFS_1.length; _i++) {
        var col = SALES_ORDER_DETAILS_REFUND_COLUMN_DEFS_1[_i];
        visibility[col.key] = true;
    }
    return visibility;
}
export function isSalesOrderDetailsRefundColumnVisible(columnVisibility, key) {
    return (columnVisibility === null || columnVisibility === void 0 ? void 0 : columnVisibility[key]) !== false;
}
export function getSalesOrderDetailsRefundColumns() {
    return SALES_ORDER_DETAILS_REFUND_COLUMN_DEFS;
}
